import { withStatusOrder } from './utils';

export const OPTIMO01 = {
    header: {
        en: 'Chat Initiated',
        hi: 'चैट शुरू हो गई है',
        kn: 'ಚಾಟ್ ಪ್ರಾರಂಭಿಸಲಾಗಿದೆ',
        ta: 'அரட்டையைத் தொடங்கியது',
        te: 'చాట్ ప్రారంభించబడింది',
    },
    label: {
        en: 'Enquiry Creation Pending',
        hi: 'पूछताछ निर्माण लंबित',
        kn: 'ವಿಚಾರಣೆಯ ರಚನೆ ಬಾಕಿಯಿದೆ',
        ta: 'விசாரணை உருவாக்கம் நிலுவையில் உள்ளது',
        te: 'విచారణ సృష్టి పెండింగ్‌లో ఉంది',
    },
    order: 1,
    color: 'info',
    description: {
        en: 'The customer has received the WhatsApp flow. Awaiting flow submission',
        hi: 'ग्राहक को व्हाट्सएप प्रवाह प्राप्त हुआ है। प्रवाह जमा होने की प्रतीक्षा है',
        kn: 'ಗ್ರಾಹಕನು ವಾಟ್ಸಾಪ್ ಫ್ಲೋವನ್ನು ಸ್ವೀಕರಿಸಿದ್ದಾನೆ. ಫ್ಲೋ ಸಲ್ಲಿಕೆಗೆ ಕಾಯುತ್ತಿದೆ',
        ta: 'வாடிக்கையாளர் வாட்ஸ்அப் அனுமதி பெற்றுள்ளார். அனுமதி சமர்ப்பிக்க காத்திருக்கிறது',
        te: 'కస్టమర్ WhatsApp ఫ్లోను స్వీకరించాడు. ఫ్లో సమర్పణ కోసం వేచి ఉంది',
    },
};

export const NAActiveCases = withStatusOrder({
    OPTIMO01
});